import { render, staticRenderFns } from "./Mddingdan.vue?vue&type=template&id=6b34ad9c&"
import script from "./Mddingdan.vue?vue&type=script&lang=js&"
export * from "./Mddingdan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports